// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"461":"44ccd2d8","669":"f1e9365f"}[chunkId] + ".chunk.js";
};